import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BeatsService } from 'src/app/services/beats-service/beats.service';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { Ga4trackingService } from 'src/app/services/ga4Tracking/ga4tracking.service';

@Component({
  selector: 'ipm-non-login-user-popup',
  templateUrl: './non-login-user-popup.component.html',
  styleUrls: ['./non-login-user-popup.component.scss']
})
export class NonLoginUserPopupComponent implements OnInit {
  @Input() isStartSelling: boolean = false;
  @Input() type: string = "";
  @Input() isMusicPlayer: boolean = true ;
  constructor(private commonService: CommonService,
    private router: Router,
  private beatService: BeatsService,
  private ga4Service : Ga4trackingService) { }

  ngOnInit(): void {
  }

  close() {
    let eventName = 'active_guest';
    let attributes = {
      label: 'Engagement',
      action : 'click',
      category : 'Beats'
    }
    this.ga4Service.sendEvent(eventName ,attributes);
    this.commonService.closePopUp();
  }

  openAuthModel(type: string) {
    let eventName = 'active_guest';
    let attributes = {
      label: 'Engagement',
      action : 'click',
      category : 'Beats'
    }
    this.ga4Service.sendEvent(eventName ,attributes);
    this.beatService.isMusicPlayOpen.next(false);
    this.commonService.closePopUp();
    let path =  type === "signup" ? "/signup" : "/signin";
    let params: any = {};
    if (this.isStartSelling) {
      params = { startSelling: true }
    }
    this.router.navigate([path], {  queryParams : params});
  }
}
